import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    name: 'maxiNet',
    path: '/maxi-net',
    component: () => import('../pages/MaxiNetPage.vue'),
    meta: {
      requiresAuth: true
    }
  }
];

export default routes;
